import { AfterViewInit, Component, ComponentFactoryResolver, EventEmitter, Input, OnInit, Output, Type, ViewChild, ViewChildren } from '@angular/core';
import { ComponentService } from '../../services/component.service';
import { FormsTemplateService } from '../../services/forms-template.service';
import { OverlaySideFormService } from '../../components/shared/overlay-side-form/overlay-side-form.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { NicaMenuService } from '../../services/nica-menu.service';
import { RentriService } from '../../services/rentri.service';
import { AnagraficaService } from '../../services/anagrafica.service';
import { NgxSpinnerService } from 'ngx-spinner';

import { NicaMaster } from '../../components/nica-master-component/nica-master.component';
import { Apiservice } from '../../services/api.service';
import { HttpClient } from '@angular/common/http';


@Component({
  selector: 'app-ana-magazzini',
  templateUrl: './ana-magazzini.component.html',
  styleUrls: ['./ana-magazzini.component.css']
})
export class AnaMagazziniComponent extends NicaMaster implements OnInit {

  @Input() showTitle: boolean = true;
  @Output() rowSelected = new EventEmitter<any>();
  help: any;
  buttonCustom2: any[] = []
  constructor(
    private activateRoute: ActivatedRoute,
    public spinner: NgxSpinnerService,
    public apiservice: Apiservice,
    public userComponentService: ComponentService,
    public templateService: FormsTemplateService,
    public _overlaySideFormService: OverlaySideFormService,
    public _overlaySidePanelService: OverlaySideFormService,
    public formTemplateService: FormsTemplateService,
    public _componentFactoryResolver: ComponentFactoryResolver,
    public activatedroute: ActivatedRoute,
    public router: Router,
    public menuService: NicaMenuService,
    public rentriService: RentriService,
    public anagraficaService: AnagraficaService,
    public http: HttpClient,


  ) {
    super(
      userComponentService,
      templateService,
      _overlaySideFormService,
      _overlaySidePanelService,
      formTemplateService,
      _componentFactoryResolver,
      activatedroute,
      router,
      menuService,
      rentriService,
      anagraficaService,

    );
  }


  ngOnInit() {

    if (this.itemData) {
      this.currentTabId = this.itemData[0].componentName,
      this.currentTabName = this.itemData[0].componentName
      this.setGlobalVariableFromParams(this.itemData[0])



    } else {
      this.activateRoute.queryParams.subscribe(params => {
        this.params = params

        console.log("Parametri=", this.params);


        this.currentTabId = params.currentTabId,
          this.currentTabName = params.currentTabName



        this.setGlobalVariableFromParams(params);


      })
    }
  }
  validateDataFieldPrepared(e: any) {
    console.log("In prepared ", e);
  }





}


